import { ReportMxData } from '../../../types';
import { getCommaSeparatedNumber } from '../../../utils/common';

interface Props {
  title: string;
  value?: number;
  unit: string;
  maxLength?: number;
  disabled: boolean;
  reportColumnName: string;
  setReportMxData: (reportMxData: ReportMxData | ((prev: ReportMxData | null) => ReportMxData)) => void; // 함수형 업데이트 지원
}

/**
 * 그룹 박스(Input + Button + unit)를 출력한다.
 * @param title: 제목을 가져온다
 * @param value: state
 * @param setValue: setState
 * @param unit: 단뤼를 지정한다
 * @param maxLength: 자릿수 제한 없으면 기본값(4자릿수)
 * @returns
 */
const InputGroup2 = ({ title, value, unit, maxLength, disabled, reportColumnName, setReportMxData }: Props) => {
  /**
     * 입력되는 값을 숫자로 변환 한다.
        1. 첫 글자는 0일 될 수 없게
        2. 숫자로 변환(정규식)
     */
  const handleOnChange = ({ target }: React.ChangeEvent<HTMLInputElement>) => {
    let result = target.value || '';

    result = result.replace(/^0/g, ''); // 1. 첫 글자가 0이면 변경
    result = result.replace(/[^0-9]/g, ''); // 2. 숫자로 변환

    setReportMxData((report: ReportMxData) => ({
      ...report, //
      [reportColumnName]: parseInt(result),
    }));
  };

  return (
    <div className="styled-group">
      <div className="styled-left2">
        <span className="title">{title}</span>
      </div>
      <div className="styled-middle">
        <input
          className="middle"
          type="text"
          // pattern="[0-9,]*"
          maxLength={maxLength ? maxLength : 6} // 기본값은 6자리
          value={getCommaSeparatedNumber(value)}
          onChange={handleOnChange}
          disabled={disabled}
        />
      </div>
      <div className="styled-right2">
        <span className="unit">{unit}</span>
      </div>
    </div>
  );
};

export default InputGroup2;
